import { render, staticRenderFns } from "./FormOptionalText.vue?vue&type=template&id=584e9c06"
import script from "./FormOptionalText.vue?vue&type=script&lang=js"
export * from "./FormOptionalText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports